import { render, staticRenderFns } from "./SpecificCommerce.vue?vue&type=template&id=7fb4e6b6&scoped=true&"
import script from "./SpecificCommerce.vue?vue&type=script&lang=js&"
export * from "./SpecificCommerce.vue?vue&type=script&lang=js&"
import style0 from "./SpecificCommerce.vue?vue&type=style&index=0&id=7fb4e6b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb4e6b6",
  null
  
)

export default component.exports